import { SignIn } from '@clerk/clerk-react';

export function SignInPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      {/* fallbackRedirectUrl is relative so demo logins stay on the demo
          origin instead of the Clerk instance's absolute prod Home URL. */}
      <SignIn routing="path" path="/sign-in" fallbackRedirectUrl="/" />
    </div>
  );
}
